
export const ProgressSpinner = () => {
	return (
		<div id="loadingProgressG">
			<div id="loadingProgressG_1" className="loadingProgressG"></div>
		</div>
	)
}